import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InitiatorRegistrationComponent } from './initiator-registration/initiator-registration.component';
import { InitiatorAccessInfoComponent } from './initiator-access-request/initiator-access-info/initiator-access-info.component';
import { InitiatorAccessRequestFormComponent } from './initiator-access-request/initiator-access-request-form/initiator-access-request-form.component';
import { InitiatorAccessRequestComponent } from './initiator-access-request/initiator-access-request.component';
import { MaterialModule } from 'src/app/modules/shared-modules/material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { InitialisationComponent } from './initialisation.component';
import { StakeholdersTableComponent } from './stakeholders/stakeholders-table/stakeholders-table.component';
import { StakeholdersComponent } from './stakeholders/stakeholders.component';
import { AssignItemsComponent } from './assign-items/assign-items.component';
import { AssignItemsFormComponent } from './assign-items/assign-items-form/assign-items-form.component';
import { SharedModule } from '../../shared-modules/shared.module';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        ReactiveFormsModule,
        SharedModule,
        InitiatorRegistrationComponent,
        InitiatorAccessRequestComponent,
        InitiatorAccessRequestFormComponent,
        InitiatorAccessInfoComponent,
        InitialisationComponent,
        StakeholdersComponent,
        StakeholdersTableComponent,
        AssignItemsFormComponent,
        AssignItemsComponent
    ]
})
export class InitialisationModule { }
